/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
  EdiOutboundInvoiceKind,
  EdiOutboundInvoiceState,
  EdiOutboundInvoicesPage,
  EdiOutboundTrackingPage,
  EdiOutboundTrackingReason,
  EdiOutboundTrackingState,
  GetEdiDeliverySettingsResponse,
  SaveEdiDeliverySettingsRequest,
  TestEdiDeliveryConnectionResponse,
} from "../models/index";
import {
  EdiOutboundInvoiceKindFromJSON,
  EdiOutboundInvoiceKindToJSON,
  EdiOutboundInvoiceStateFromJSON,
  EdiOutboundInvoiceStateToJSON,
  EdiOutboundInvoicesPageFromJSON,
  EdiOutboundInvoicesPageToJSON,
  EdiOutboundTrackingPageFromJSON,
  EdiOutboundTrackingPageToJSON,
  EdiOutboundTrackingReasonFromJSON,
  EdiOutboundTrackingReasonToJSON,
  EdiOutboundTrackingStateFromJSON,
  EdiOutboundTrackingStateToJSON,
  GetEdiDeliverySettingsResponseFromJSON,
  GetEdiDeliverySettingsResponseToJSON,
  SaveEdiDeliverySettingsRequestFromJSON,
  SaveEdiDeliverySettingsRequestToJSON,
  TestEdiDeliveryConnectionResponseFromJSON,
  TestEdiDeliveryConnectionResponseToJSON,
} from "../models/index";

export interface DeleteDeliverySettingsRequest {
  companyId: string;
}

export interface GetDeliverySettingsRequest {
  companyId: string;
}

export interface GetOutboundInvoicesRequest {
  companyId: string;
  search?: string | null;
  state?: EdiOutboundInvoiceState | null;
  kind?: EdiOutboundInvoiceKind | null;
  page?: number | null;
  pageSize?: number | null;
}

export interface GetOutboundTrackingRequest {
  companyId: string;
  search?: string | null;
  state?: EdiOutboundTrackingState | null;
  reason?: EdiOutboundTrackingReason | null;
  page?: number | null;
  pageSize?: number | null;
}

export interface SaveDeliverySettingsRequest {
  saveEdiDeliverySettingsRequest: SaveEdiDeliverySettingsRequest;
}

export interface SendOutboundInvoiceRequest {
  ediOutboundInvoiceId: string;
}

export interface SendOutboundTrackingRequest {
  ediOutboundTrackingId: string;
}

export interface TestDeliveryConnectionRequest {
  companyId: string;
}

/**
 *
 */
export class EDIApi extends runtime.BaseAPI {
  /**
   */
  async deleteDeliverySettingsRaw(
    requestParameters: DeleteDeliverySettingsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["companyId"] == null) {
      throw new runtime.RequiredError(
        "companyId",
        'Required parameter "companyId" was null or undefined when calling deleteDeliverySettings().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["companyId"] != null) {
      queryParameters["companyId"] = requestParameters["companyId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/edi/delivery-settings`,
        method: "DELETE",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async deleteDeliverySettings(
    requestParameters: DeleteDeliverySettingsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.deleteDeliverySettingsRaw(requestParameters, initOverrides);
  }

  /**
   */
  async getDeliverySettingsRaw(
    requestParameters: GetDeliverySettingsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<GetEdiDeliverySettingsResponse>> {
    if (requestParameters["companyId"] == null) {
      throw new runtime.RequiredError(
        "companyId",
        'Required parameter "companyId" was null or undefined when calling getDeliverySettings().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["companyId"] != null) {
      queryParameters["companyId"] = requestParameters["companyId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/edi/delivery-settings`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GetEdiDeliverySettingsResponseFromJSON(jsonValue),
    );
  }

  /**
   */
  async getDeliverySettings(
    requestParameters: GetDeliverySettingsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<GetEdiDeliverySettingsResponse> {
    const response = await this.getDeliverySettingsRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async getOutboundInvoicesRaw(
    requestParameters: GetOutboundInvoicesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<EdiOutboundInvoicesPage>> {
    if (requestParameters["companyId"] == null) {
      throw new runtime.RequiredError(
        "companyId",
        'Required parameter "companyId" was null or undefined when calling getOutboundInvoices().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["companyId"] != null) {
      queryParameters["companyId"] = requestParameters["companyId"];
    }

    if (requestParameters["search"] != null) {
      queryParameters["search"] = requestParameters["search"];
    }

    if (requestParameters["state"] != null) {
      queryParameters["state"] = requestParameters["state"];
    }

    if (requestParameters["kind"] != null) {
      queryParameters["kind"] = requestParameters["kind"];
    }

    if (requestParameters["page"] != null) {
      queryParameters["page"] = requestParameters["page"];
    }

    if (requestParameters["pageSize"] != null) {
      queryParameters["pageSize"] = requestParameters["pageSize"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/edi/outbound-invoices`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      EdiOutboundInvoicesPageFromJSON(jsonValue),
    );
  }

  /**
   */
  async getOutboundInvoices(
    requestParameters: GetOutboundInvoicesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<EdiOutboundInvoicesPage> {
    const response = await this.getOutboundInvoicesRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async getOutboundTrackingRaw(
    requestParameters: GetOutboundTrackingRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<EdiOutboundTrackingPage>> {
    if (requestParameters["companyId"] == null) {
      throw new runtime.RequiredError(
        "companyId",
        'Required parameter "companyId" was null or undefined when calling getOutboundTracking().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["companyId"] != null) {
      queryParameters["companyId"] = requestParameters["companyId"];
    }

    if (requestParameters["search"] != null) {
      queryParameters["search"] = requestParameters["search"];
    }

    if (requestParameters["state"] != null) {
      queryParameters["state"] = requestParameters["state"];
    }

    if (requestParameters["reason"] != null) {
      queryParameters["reason"] = requestParameters["reason"];
    }

    if (requestParameters["page"] != null) {
      queryParameters["page"] = requestParameters["page"];
    }

    if (requestParameters["pageSize"] != null) {
      queryParameters["pageSize"] = requestParameters["pageSize"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/edi/outbound-tracking`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      EdiOutboundTrackingPageFromJSON(jsonValue),
    );
  }

  /**
   */
  async getOutboundTracking(
    requestParameters: GetOutboundTrackingRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<EdiOutboundTrackingPage> {
    const response = await this.getOutboundTrackingRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async saveDeliverySettingsRaw(
    requestParameters: SaveDeliverySettingsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["saveEdiDeliverySettingsRequest"] == null) {
      throw new runtime.RequiredError(
        "saveEdiDeliverySettingsRequest",
        'Required parameter "saveEdiDeliverySettingsRequest" was null or undefined when calling saveDeliverySettings().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/edi/delivery-settings`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: SaveEdiDeliverySettingsRequestToJSON(
          requestParameters["saveEdiDeliverySettingsRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async saveDeliverySettings(
    requestParameters: SaveDeliverySettingsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.saveDeliverySettingsRaw(requestParameters, initOverrides);
  }

  /**
   */
  async sendOutboundInvoiceRaw(
    requestParameters: SendOutboundInvoiceRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<boolean>> {
    if (requestParameters["ediOutboundInvoiceId"] == null) {
      throw new runtime.RequiredError(
        "ediOutboundInvoiceId",
        'Required parameter "ediOutboundInvoiceId" was null or undefined when calling sendOutboundInvoice().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["ediOutboundInvoiceId"] != null) {
      queryParameters["ediOutboundInvoiceId"] =
        requestParameters["ediOutboundInvoiceId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/edi/send-outbound-invoice`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    if (this.isJsonMime(response.headers.get("content-type"))) {
      return new runtime.JSONApiResponse<boolean>(response);
    } else {
      return new runtime.TextApiResponse(response) as any;
    }
  }

  /**
   */
  async sendOutboundInvoice(
    requestParameters: SendOutboundInvoiceRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<boolean> {
    const response = await this.sendOutboundInvoiceRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async sendOutboundTrackingRaw(
    requestParameters: SendOutboundTrackingRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<boolean>> {
    if (requestParameters["ediOutboundTrackingId"] == null) {
      throw new runtime.RequiredError(
        "ediOutboundTrackingId",
        'Required parameter "ediOutboundTrackingId" was null or undefined when calling sendOutboundTracking().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["ediOutboundTrackingId"] != null) {
      queryParameters["ediOutboundTrackingId"] =
        requestParameters["ediOutboundTrackingId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/edi/send-outbound-tracking`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    if (this.isJsonMime(response.headers.get("content-type"))) {
      return new runtime.JSONApiResponse<boolean>(response);
    } else {
      return new runtime.TextApiResponse(response) as any;
    }
  }

  /**
   */
  async sendOutboundTracking(
    requestParameters: SendOutboundTrackingRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<boolean> {
    const response = await this.sendOutboundTrackingRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async testDeliveryConnectionRaw(
    requestParameters: TestDeliveryConnectionRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<TestEdiDeliveryConnectionResponse>> {
    if (requestParameters["companyId"] == null) {
      throw new runtime.RequiredError(
        "companyId",
        'Required parameter "companyId" was null or undefined when calling testDeliveryConnection().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["companyId"] != null) {
      queryParameters["companyId"] = requestParameters["companyId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/edi/test-delivery-connection`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      TestEdiDeliveryConnectionResponseFromJSON(jsonValue),
    );
  }

  /**
   */
  async testDeliveryConnection(
    requestParameters: TestDeliveryConnectionRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<TestEdiDeliveryConnectionResponse> {
    const response = await this.testDeliveryConnectionRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }
}
